import { toast } from "sonner";

// PDF prints bypass Browser Print entirely, so nothing can ever confirm them —
// the printed stamp must NOT fire. Say so at the moment it happens, every time.
export function notifyPdfNoStamp() {
  toast.info("PDF prints don't update printed status — the label will still show as unprinted.", { duration: 7000 });
}
